// extracted by mini-css-extract-plugin
export default {"author_image":"Author_author_image__em5Gd","link_underline":"Author_link_underline__4qrv4"};